import { Dto, DtoWithId } from "@mango/core";
import { Artikel } from './artikel';
import { Relatie } from "./relatie";

@Dto({fullName: "CIJBorculo.Logic.ArtikelLeverancier"})
export class ArtikelLeverancier extends DtoWithId {
	artikelID: Artikel;
	leverancierID: Relatie;
	artikelCodeLeverancier: string;
	prijs: number;
	datum: Date;
	prijsPerEenheid: number;
	factor: number;
	eenheid: string;
	aantalVerpakking: number;
}